import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import {
  changeLayout,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions";
// Other Layout related Component
import Header from "./Header";
import Footer from "./Footer";

import { verifyData } from "../../pages/Common/CommonFunctions/commonFunctions";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

class Layout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMenuOpened: false,
      marginTop: "",
    };
  }

  componentDidMount() {
    // Scrollto 0,0
    window.scrollTo(0, 0);

    const title = this.props.location.pathname;
    let currentage = title.charAt(1).toUpperCase() + title.slice(2);

    document.title = currentage + " | HireNeuron";

    this.props.changeLayout("horizontal");
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme);
    }
    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth);
    }
    let data = JSON.parse(localStorage.getItem("authUser"));
    if (
      localStorage.getItem("impersonationMode") !== undefined &&
      localStorage.getItem("impersonationMode") !== null
    ) {
      this.setState({ marginTop: "impersonate-mode" });
    }
  }

  /**
   * Opens the menu - mobile
   */
  openMenu = () => {
    this.setState({ isMenuOpened: !this.state.isMenuOpened });
  };

  render() {
    const data = JSON.parse(localStorage.getItem("authUser"));

    const handleImpersonateMode = () => {
      let companyId = JSON.parse(localStorage.getItem("authUser")).companyId;
      localStorage.removeItem("authUser");
      if (
        localStorage.getItem("secondaryStorage") != null &&
        localStorage.getItem("secondaryStorage") !== undefined
      ) {
        localStorage.setItem(
          "authUser",
          localStorage.getItem("secondaryStorage"),
        );
        localStorage.removeItem("secondaryStorage");
      } else {
        localStorage.removeItem("isAuthProtected");
      }
      localStorage.removeItem("impersonationMode");
      window.location =
        process.env.REACT_APP_Admin_UI + `organization/${companyId}/admin-users`;
      // process.env.REACT_APP_Admin_UI + `admin/company/${companyId}`;
      // organization/5/admin-users
      localStorage.setItem("reloadMessage", "reload");
    };
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div id="layout-wrapper">
            <header id="page-topbar">
              {/* impersonate mode banner for admin only */}
              {localStorage.getItem("impersonationMode") !== undefined &&
                localStorage.getItem("impersonationMode") !== null ? (
                <div className="bg-info banner-impersonate-mode p-3">
                  {" "}
                  You are in Impersonation mode.{" "}
                  <button
                    onClick={(e) => {
                      handleImpersonateMode();
                    }}
                    className="btn btn-danger"
                  >
                    Click
                  </button>{" "}
                  to end this session
                </div>
              ) : (
                <div className="d-none"></div>
              )}

              <Header
                theme={this.props.topbarTheme}
                isMenuOpened={this.state.isMenuOpened}
                openLeftMenuCallBack={this.openMenu}
              ></Header>
            </header>

            <div className={"main-content " + this.state.marginTop}>
              {this.props.children}

              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Layout.propTypes = {
  changeLayout: PropTypes.func,
  changeLayoutWidth: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

const mapStatetoProps = (state) => {
  return {
    ...state.Layout,
  };
};
export default connect(mapStatetoProps, {
  changeTopbarTheme,
  changeLayout,
  changeLayoutWidth,
})(withRouter(Layout));
